
export const APP_URL = typeof window !== 'undefined' ? window.location.origin : 'https://charge.mer.eco';
export const GMT_ID = 'GTM-KJWWHXX';
export const ALLOW_MOCK = false

